import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LowLevelApi } from '@app/shared/services/state/low-level-api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private router = inject(Router);
  private llapi = inject(LowLevelApi);


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const authenticated = this.llapi.getValue('auth.authenticated');
    if (authenticated) {
      return true;
    }
    if (route.toString() === '/login') {
      return true;
    }
    console.log('navigate to login');
    this.router.navigate(['/login'], {
      queryParams: {routeAfterLogin: state.url},
      replaceUrl:  true
    });
    return false;
  }

}
